import React from "react";

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (error.name === "ChunkLoadError") {
      return { hasError: true };
    }
    throw error;
  }

  componentDidCatch() {
    window.location.reload();
  }

  render() {
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
